export const LayoutElements = {
    SupportWorkspace: "support-workspace",
}